module.exports = __webpack_public_path__ + "img/esquema-construccion.f87cd5f8.jpg";